<template>
  <div class="navbar">
    <app-link to="/" v-if="!hideNavAction">
      <img src="@/assets/home.png" class="icon-home normal-button" />
    </app-link>
    <span class="nav-title">{{ pageTitle }}</span>
    <app-link to="checkout" v-if="!hideNavAction">
      <cart class="cart-container normal-button" :badge="this.items.length" />
    </app-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cart from "@/components/Cart";
import AppLink from "@/components/Link";

export default {
  name: "Navbar",
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
    hideNavAction: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Cart,
    AppLink,
  },
  computed: {
    ...mapGetters(["device", "items"]),
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  background: #FFF9EC;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .icon-home {
    width: 30px;
    height: auto;
    margin: 0 15px;
  }

  .cart-container {
  }

  .nav-title {
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #222222;
    flex: 1;
    text-align: center;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
